<ppb-start-container>
  <form [formGroup]="loginForm" autocomplete="off">
    <div>
      <div *ngIf="step <= 1">
        <h3 class="login-title" i18n="@@login.title">Zaloguj się</h3>
        <div
          *ngIf="actionParam === 'password-changed'"
          class="confirm-message"
          i18n="@@login.password_changed"
        >
          Twoje hasło zostało zmienione
        </div>
        <div class="login-field-cont">
          <div class="o-form-group">
            <pseic-form-field
              label="E-mail"
              labelFor="username"
              i18n-label="@@common.email"
              [dataTestId]="'username-form-field'"
            >
              <input
                class="o-form-field"
                placeholder="Twój adres e-mail"
                id="username"
                [attr.data-testid]="'username-input'"
                type="text"
                pseicAutofocus
                formControlName="usernameControl"
                autocomplete="username email"
                i18n-placeholder="@@login.user_email"
              />
            </pseic-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between stretch">
          <div>
            <a
              routerLink="/account-registration"
              i18n="@@account.account_registration"
              >Zarejestruj się</a
            >
          </div>
          <div>
            <pseic-async-button
              *ngIf="step === 1"
              [type]="ButtonType.SUBMIT"
              [isLoading$]="isLoading$"
              (buttonClicked)="nextStep(2)"
              [attr.data-testid]="'login-next-button'"
              i18n="@@common.next"
              >Dalej
            </pseic-async-button>
          </div>
        </div>
      </div>
      <div *ngIf="step != 1">
        <h5 class="login-title">{{ loginForm.getRawValue().username }}</h5>
        <div class="login-field-cont">
          <div class="o-form-group">
            <pseic-form-field
              label="Hasło"
              labelFor="password"
              [resizeOnError]="true"
              [dataTestId]="'password-form-field'"
              i18n-label="@@login.password"
            >
              <div class="o-form-field-btn-holder">
                <input
                  class="o-form-field o-form-field-btn-holder__field"
                  pseicAutofocus
                  #passwordField
                  placeholder="Podaj hasło"
                  type="password"
                  [attr.data-testid]="'password-input'"
                  autocomplete="current-password"
                  formControlName="passwordControl"
                  i18n-placeholder="@@login.current_password"
                />
                <div
                  class="o-form-field-btn-holder__btn"
                  (click)="
                    passwordField.type === 'password'
                      ? (passwordField.type = 'text')
                      : (passwordField.type = 'password')
                  "
                >
                  <psei-icon
                    class="o-form-field-btn-holder__icon"
                    name="view"
                    [size]="iconSize"
                  >
                  </psei-icon>
                </div>
              </div>
            </pseic-form-field>
          </div>
          <div class="auth-code-container">
            <a
              class="noselect"
              routerLink="/password-reset"
              [state]="emailState"
              [attr.data-testid]="'reset-password-link'"
              i18n="@@login.password_reset"
              >Zapomniałeś hasła?</a
            >
          </div>
          <div *ngIf="step === 3" class="auth-code-container">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
              <div i18n="@@common.enter_sms_code_colon">Podaj kod SMS:</div>
              <div>
                <pseic-form-field
                  [resizeOnError]="false"
                  [attr.data-testid]="'sms-form-field'"
                >
                  <input
                    class="o-form-field auth-code"
                    placeholder="Kod SMS"
                    [attr.data-testid]="'sms-input'"
                    pseicAutofocus
                    type="number"
                    formControlName="smsCodeControl"
                    i18n-placeholder="@@common.sms_code"
                  />
                </pseic-form-field>
              </div>
            </div>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between stretch">
          <div></div>
          <div>
            <div
              *ngIf="step === 2"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="8px"
            >
              <pseic-async-button
                [flavor]="'SECONDARY'"
                (buttonClicked)="nextStep(1)"
                i18n="@@common.back"
                >Wstecz
              </pseic-async-button>
              <pseic-async-button
                *ngIf="step === 2"
                [type]="ButtonType.SUBMIT"
                [attr.data-testid]="'password-next-button'"
                [isLoading$]="isLoading$"
                (buttonClicked)="nextStep(3)"
                i18n="@@common.next"
                >Dalej
              </pseic-async-button>
            </div>
            <div
              *ngIf="step === 3"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="8px"
            >
              <pseic-async-button
                [type]="ButtonType.BUTTON"
                [flavor]="ButtonFlavor.SECONDARY"
                (buttonClicked)="nextStep(2)"
                i18n="@@common.back"
                >Wstecz
              </pseic-async-button>

              <pseic-async-button
                [type]="ButtonType.SUBMIT"
                [isLoading$]="isLoading$"
                [attr.data-testid]="'sms-next-button'"
                (buttonClicked)="nextStep(4)"
                i18n="@@login.next_step4"
                >Zaloguj
              </pseic-async-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ppb-start-container>
